import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/total/styles.scss';export default {
  "total": "_total_1hpq1_1",
  "day": "_day_1hpq1_7",
  "record": "_record_1hpq1_14",
  "hovered": "_hovered_1hpq1_28",
  "button": "_button_1hpq1_28",
  "pendingValidation": "_pendingValidation_1hpq1_29",
  "lockedHover": "_lockedHover_1hpq1_33",
  "lockedButton": "_lockedButton_1hpq1_38",
  "validated": "_validated_1hpq1_43",
  "text": "_text_1hpq1_54",
  "deadline": "_deadline_1hpq1_60",
  "checkMark": "_checkMark_1hpq1_72"
};